export enum FlowModalContentType {
  Raw,
  FullWidth,
  FixedWidth,
}
